module.exports = __webpack_public_path__ + "img/header-memoireRingsColored.2781fe3.jpg";